import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
  TableContainer,
  Paper,
  Theme,
  Tooltip,
  Divider,
} from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import ScheduleIcon from "@material-ui/icons/Schedule";
import StorageIcon from "@material-ui/icons/Storage";
import LanguageIcon from "@material-ui/icons/Language";
import { LayoutConst } from "../../constants";
import { FileTypeIcon } from "../filetype/FileTypeIcon";
import { DocumentItemType } from "../../types";
import { ActionLink } from "../url/ActionLink";
import { getFileTypeIcon } from "../../helpers";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textSearchContainer: {
      minWidth: LayoutConst.table.minWidth.default,
      overflowY: "auto",
      minHeight: 300,
      height: "100%",
    },
    virtualFolderContainer: {
      width: "100%",
      overflowY: "auto",
      minHeight: 300,
      height: "100%",
    },
    table: {
      borderCollapse: "collapse",
      margin: "0 auto",
      width: "100%",
    },
    tbody: {
      width: "100%",
    },
    tr: {
      cursor: "context-menu",
      marginTop: "0.75rem",
      boxSizing: "content-box",
    },
    tdNo: {
      width: "3%",
      textAlign: "center",
      verticalAlign: "top",
      padding: "0.4rem 0.5rem 0.25rem 0.5rem",
    },
    tdFilename: {
      width: "60%",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.primary.dark,
      fontSize: "1rem",
      fontWeight: "bold",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: 0,
    },
    tdFileType: {
      width: "15%",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
    },
    tdCreateDate: {
      width: "auto",
      minWidth: "155px",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.text.secondary,
    },
    tdThumbnail: {
      width: "95px",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
    },
    tdDirPath: {
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.secondary.dark,
      fontSize: "0.75rem",
    },
    tdUrl: {
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      fontSize: "0.75rem",
    },
    tdSourceType: {
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.25rem",
      color: "rgba(0,0,0,0.87)",
    },
    tdUpdateDate: {
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.text.secondary,
    },
    tdFirstStr: {
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: 0,
    },
    tdNone1: {
      textAlign: "left",
      padding: "0",
    },
    tdBorder: {
      padding: "0.25rem 0.75rem 0.25rem 0.75rem",
    },
    iconSourceType: {
      fontSize: 16,
      marginTop: "0.1rem",
      marginRight: "0.3rem",
    },
    imgThumb: {
      objectFit: "contain",
      maxWidth: "90px",
      maxHeight: "85px",
      border: "1px solid #000",
    },
  })
);

interface Props {
  rows: DocumentItemType[];
  currentPage?: number;
  displayCount?: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  contextMenu: JSX.Element;
  containerType: string;
}

/** 検索結果詳細表示 */
export function ContentDetailTable(props: Props) {
  const classes = useStyles();

  //------------------------------
  // Result 検索結果
  // [State]
  const { rows } = props;

  //------------------------------
  // ページ情報
  // currentPage 現在ページ番号
  // displayCount 1ページの表示上限数
  // [State]
  const { currentPage } = props;
  const { displayCount } = props;

  //------------------------------
  // コンテキストメニュー
  // [State]
  const { contextMenu } = props;
  // [Handler]
  const { onClick } = props;

  //------------------------------
  // コンテナータイプ
  const { containerType } = props;

  //------------------------------
  // 検索結果の行描画
  // 検索結果1件に付き3行1セットで描画 + borderの描画
  const getTrs = () => {
    const trs: JSX.Element[] = [];
    rows.forEach((row, i) => {
      const key = `${i}-${row.filename}`;
      // 1行目
      trs.push(
        <tr
          id={`data-${i}-1`}
          className={classes.tr}
          key={`${key}-1`}
          onContextMenu={onClick}
        >
          <td className={classes.tdNo} rowSpan={3}>
            {currentPage && displayCount
              ? (currentPage - 1) * displayCount + i + 1
              : i + 1}
          </td>
          <td className={classes.tdFilename}>
            <FileTypeIcon fileType={row.file_type} />
            {row.filename}
          </td>
          {/* <td className={classes.tdFileType}>
            <FileTypeIcon fileType={row.file_type} />
            {row.file_type}
          </td> */}
          {/* [HP稼働]: electronからの修正(不要項目削除) */}
          {/* <td className={classes.tdCreateDate}>
            <Tooltip title="作成日時" aria-label="作成日時">
              <div style={{ display: "flex", alignItems: "center" }}>
                <ScheduleIcon
                  fontSize="small"
                  style={{
                    display: "inline-flex",
                    verticalAlign: "middle",
                    width: 19,
                    height: 19,
                    marginRight: "0.25rem",
                    marginLeft: 1,
                  }}
                />
                {row.create_date}
              </div>
            </Tooltip>
          </td> */}
          {/* <td className={classes.tdThumbnail} rowSpan={3}>
            {row.thumb === "" ? (
              getFileTypeIcon(row.file_type, "6x", 0.22)
            ) : (
              <img
                src={`data:image/jpeg;base64,${row.thumb}`}
                className={classes.imgThumb}
                alt={row.filename}
              />
            )}
          </td> */}
        </tr>
      );
      // 2行目
      trs.push(
        <tr
          id={`data-${i}-2`}
          className={classes.tr}
          key={`${key}-2`}
          onContextMenu={onClick}
        >
          <td
            className={
              row.source_type === "NAS" ? classes.tdDirPath : classes.tdUrl
            }
          >
            {row.source_type === "NAS" ? (
              row.dirpath
            ) : (
              <ActionLink url={row.url} />
            )}
          </td>
          {/* [HP稼働]: electronからの修正(不要項目削除) */}
          {/* <td className={classes.tdSourceType}>
            {row.source_type === "NAS" ? (
              <>
                <StorageIcon className={classes.iconSourceType} />
                <span style={{ verticalAlign: "top" }}>ファイル</span>
              </>
            ) : (
              <>
                <LanguageIcon className={classes.iconSourceType} />
                <span style={{ verticalAlign: "top" }}>ウェブ</span>
              </>
            )}
          </td> */}
          {/* [HP稼働]: electronからの修正(不要項目削除) */}
          {/* <td className={classes.tdUpdateDate}>
            <Tooltip title="更新日時" aria-label="更新日時">
              <div style={{ display: "flex", alignItems: "center" }}>
                <HistoryIcon
                  fontSize="small"
                  style={{
                    display: "inline-flex",
                    verticalAlign: "middle",
                    marginRight: "0.25rem",
                  }}
                />
                {row.update_date}
              </div>
            </Tooltip>
          </td> */}
        </tr>
      );
      // 3行目
      trs.push(
        <tr
          id={`data-${i}-3`}
          className={classes.tr}
          key={`${key}-3`}
          onContextMenu={onClick}
        >
          {/* [HP稼働]: electronからの修正(不要項目削除) */}
          {/* <td className={classes.tdFirstStr} colSpan={2}> */}
          <td className={classes.tdFirstStr}>
            {row.first_str}
          </td>
          {/* [HP稼働]: electronからの修正(不要項目削除) */}
          {/* <td className={classes.tdNone1} /> */}
        </tr>
      );
      // borderの追加
      if (i + 1 !== rows.length) {
        trs.push(
          <tr id={`data-${i}-4`} className={classes.tr} key={`${key}-4`}>
            <td className={classes.tdBorder} colSpan={5}>
              <Divider variant="middle" />
            </td>
          </tr>
        );
      }
    });
    return trs;
  };

  //--------------------
  // コンポーネント
  return (
    <TableContainer
      className={
        containerType === "textSearch"
          ? classes.textSearchContainer
          : classes.virtualFolderContainer
      }
      component={Paper}
    >
      <table className={classes.table}>
        <tbody className={classes.tbody}>{getTrs()}</tbody>
      </table>
      {contextMenu}
    </TableContainer>
  );
}
